import { Link } from 'react-router';

import { GlassSurface } from '@components/glass/GlassSurface';
import { Icon } from '@components/ui/Icon';
import { SERVICES } from '@config/services';

import styles from './ServicesGrid.module.scss';

/**
 * Six services as cards, each linking to its full entry on the services
 * page. The whole card is the click target, via a stretched link, but only
 * the title is announced as the link text.
 *
 * Frost without refraction: the cards sit over soft ambient light, where a
 * bent rim is invisible, and six in view at once is a measurable cost.
 */
export const ServicesGrid = () => (
  <ul role="list" className={styles.grid}>
    {SERVICES.map((service) => (
      <GlassSurface
        as="li"
        key={service.id}
        interactive
        refract={false}
        className={styles.card}
        data-reveal=""
      >
        <span className={styles.icon}>
          <Icon name={service.icon} size={22} />
        </span>
        <h3 className={styles.title}>
          <Link to={`/services#${service.id}`} viewTransition className={styles.link}>
            {service.title}
          </Link>
        </h3>
        <p className={styles.summary}>{service.summary}</p>
        <Icon name="arrowUpRight" className={styles.arrow} />
      </GlassSurface>
    ))}
  </ul>
);
